import React from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line import/prefer-default-export
export const newCreditCardLabel = (
    <FormattedMessage id="CreditCardPicker.newCreditCardLabel" defaultMessage="Enter a new card" />
);
